const getRecaptchaKey = (tenant, locale) =>
  fetch(
    `/circulation-proxy/captcha/siteKey?tenant_id=${tenant}&locale=${locale.language}-${locale.country}`
  ).then(res => res.json());

export default { getRecaptchaKey };
